import { useTranslation } from 'react-i18next';
import * as S from './EditAdNoAccess.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { PageTopControls } from '@/components/PageTopControls/PageTopControls';
import { Header } from '@/components/Header';

export const EditAdNoAccessView = () => {
  const { t } = useTranslation();

  return (
    <S.Wrapper>
      <PageTopControls>
        <Header hasAddNew />
      </PageTopControls>
      <S.Container>
        <S.MessageBox>
          <IconBox
            $filename="banned.png"
            $width={114}
            $height={82}
            $iconWidth={114}
            $iconHeight={82}
          />
          <S.TextBox>
            <S.Title $variant="5">{t('common.no_access')}</S.Title>
            <S.Description>{t('common.no_access_to_page')}</S.Description>
          </S.TextBox>
        </S.MessageBox>
      </S.Container>
    </S.Wrapper>
  );
};

EditAdNoAccessView.displayName = 'EditAdNoAccessView';
